import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';

import { FormsModule } from '@angular/forms';
import { AuthGuard } from '../guards/auth.guard';
import { PermissionGuard } from '../guards/permission.guard';

import { SharedModule } from './shared.module';
import { BbTableModule } from './bb-table.module';
import { PipesModule } from './pipes.module';

import { PublicationComponent } from './../components/publication/publication.component';
import { PublicationSettingsComponent } from '../components/publication/settings/publication-settings.component';
import { PublicationCustomThumbnailsComponent } from '../components/publication/settings/publication-custom-thumbnails.component';
import { PublicationUsageStatsComponent } from '../components/publication/publication-usage-stats.component';
import { CustomFieldListComponent } from '../components/publication/custom-field/custom-field-list.component';
import { CustomFieldDetailsComponent } from '../components/publication/custom-field/custom-field-details.component';
import { UserListComponent } from './../components/publication/users/user-list.component';
import { UserDetailsComponent } from './../components/publication/users/user-details.component';
import { ApiKeyListComponent } from '../components/publication/apikeys/api-key-list.component';
import { ApiKeyDetailsComponent } from '../components/publication/apikeys/api-key-details.component';
import { BidAdaptersComponent } from './../components/publication/bid-adapters/bid-adapters.component';

import { BbPublicationMenuComponent } from './../components/publication/bb-publication-menu.component';

import { NavigateAwayGuard } from '../components/shared/abstract-details.component';
import { UploadCredentialsListComponent } from '../components/publication/upload-credentials/upload-credentials-list.component';
import { UploadCredentialsDetailsComponent } from '../components/publication/upload-credentials/upload-credentials-details.component';

const moduleRoutes: Routes = [
	{
		path: 'publication',
		component: PublicationComponent,
		canActivate: [AuthGuard],
		children: [
			{ path: 'config', redirectTo: 'config/settings', pathMatch: 'full' },
			{ path: 'config/settings', component: PublicationSettingsComponent, canDeactivate: [NavigateAwayGuard] },
			{ path: 'custom-fields', redirectTo: 'custom-fields/mediaclip', data: { class: 'has-header has-sidebar'}},
			{ path: 'custom-fields/mediaclip', component: CustomFieldListComponent, canActivate: [PermissionGuard], data: {
				permissions: ['publicationconfig']
			}},
			{ path: 'custom-field/mediaclip', component: CustomFieldDetailsComponent, canActivate: [PermissionGuard], data: {
				permissions: ['publicationconfig']
			}},
			{ path: 'custom-field/mediaclip/:name', component: CustomFieldDetailsComponent, canActivate: [PermissionGuard], data: {
				permissions: ['publicationconfig']
			}},
			{ path: 'users', component: UserListComponent, canActivate: [PermissionGuard], data: {
				permissions: ['usermanagement'], class: 'has-header has-sidebar'
			}},
			{ path: 'users/:id', component: UserDetailsComponent, canDeactivate: [NavigateAwayGuard], canActivate: [PermissionGuard], data: {
				permissions: ['usermanagement']
			}},
			{ path: 'usage', component: PublicationUsageStatsComponent, canActivate: [PermissionGuard], data: {
				class: 'has-header has-sidebar'
			}},
			{ path: 'api-keys', component: ApiKeyListComponent, canActivate: [PermissionGuard], data: {
				permissions: ['apikeys'], class: 'has-header has-sidebar'
			}},
			{ path: 'api-keys/:id', component: ApiKeyDetailsComponent, canDeactivate: [NavigateAwayGuard], canActivate: [PermissionGuard], data: {
				permissions: ['apikeys']
			}},
			{ path: 'upload-credentials', component: UploadCredentialsListComponent, canActivate: [PermissionGuard], data: {
				permissions: ['apikeys'], class: 'has-header has-sidebar'
			}},
			{ path: 'upload-credentials/:id', component: UploadCredentialsDetailsComponent, canDeactivate: [NavigateAwayGuard], canActivate: [PermissionGuard], data: {
				permissions: ['apikeys']
			}},
		]
	}
];


@NgModule({
	imports: [
		RouterModule.forChild(moduleRoutes),
		CommonModule,
		SharedModule,
		PipesModule,
		FormsModule,
		BbTableModule
	],
	declarations: [
		PublicationComponent,
		PublicationSettingsComponent,
		PublicationCustomThumbnailsComponent,
		CustomFieldListComponent,
		CustomFieldDetailsComponent,
		UserListComponent,
		UserDetailsComponent,
		PublicationUsageStatsComponent,
		ApiKeyListComponent,
		ApiKeyDetailsComponent,
		BidAdaptersComponent,
		UploadCredentialsListComponent,
		UploadCredentialsDetailsComponent
	],
	exports: [
		PublicationComponent,
		PublicationSettingsComponent,
		PublicationCustomThumbnailsComponent,
		CustomFieldListComponent,
		CustomFieldDetailsComponent,
		UserListComponent,
		UserDetailsComponent,
		PublicationUsageStatsComponent,
		ApiKeyListComponent,
		BbPublicationMenuComponent,
		ApiKeyDetailsComponent,
		BidAdaptersComponent,
		UploadCredentialsListComponent,
		UploadCredentialsDetailsComponent
	],
	providers: [
		BbPublicationMenuComponent
	]
})

export class PublicationModule {
}
